<template>
    <div class="panel">
        <div class="panel-heading message-header">
            Your Two Factor Devices
            <hcp-help>These are the two factor devices registered to your account.</hcp-help>
        </div>
        <div v-for="device in this.twoFactorDevices" :key="device.id" class="panel-block" style="display:flex; justify-content: space-between;">
            {{ device.name }}:
            <span v-if="device.type === 'app'">Via Authenticator App</span>
            <span v-if="device.type === 'sms'">Send text message to: {{device.data}}</span>
            <span v-if="device.type === 'static'"><a
                    @click="showTokens(device)">Click here to see your backup tokens.</a></span>
            <button @click="removeTwoFactorDevice(device.id)" class="delete"></button>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapState} from "vuex";
    import HcpHelp from "../HcpHelp";

    const TokenModal = {
        props: ['tokens'],
        template: `
            <div class="modal-card" style="width: auto">
                <header class="modal-card-head">
                    <p class="modal-card-title">Backup Tokens</p>
                </header>
                <section class="modal-card-body">
                    <ul>
                        <li v-for="token in tokens" v-bind:key="token">{{token}}</li>
                    </ul>
                </section>
            </div>
        `
    };
    export default {
        name: "ShowDevice",
        components: {HcpHelp},
        props: {
            'device': Object,
        },
        data: function () {
            return {
            }
        },
        computed: {
            ...mapState('user', [
                'twoFactorDevices',
            ]),
        },
        methods: {
            ...mapActions('user',[
                'removeTwoFactorDevice',
            ]),
            showTokens(device) {
                this.$modal.open({
                    parent: this,
                    component: TokenModal,
                    hasModalCard: true,
                    props: {'tokens': device.data},
                })
            },
        }
    }
</script>

<style scoped>

</style>